import { Capacitor } from "@capacitor/core";

/**
 * Hybrid storage utility that uses Capacitor Preferences on native platforms
 * and localStorage in browser for reliable cross-platform storage
 */

// Keys for storage
export const STORAGE_KEYS = {
	ACCESS_TOKEN: "access_token",
	EMAIL: "email",
	TOPIC_SUBSCRIPTION_ALL_USERS: "topic_subscription_all_users",
	COURSE_PROGRESS: "course_progress",
	VIDEO_PROGRESS: "video_progress",
	OFFLINE_VIDEOS: "offline_videos",
	APP_UPDATE_POSTPONE_UNTIL: "app_update_postpone_until",
} as const;

/**
 * Check if we're running on a native platform (iOS/Android)
 */
export const isNativePlatform = (): boolean => {
	return Capacitor.isNativePlatform();
};
